(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-hawa-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ma-hawa-shop')) {
    customElements.define(
      'ma-hawa-shop',
      class MaHawaShop extends HTMLElement {
        connectedCallback() {
          this.minimumOrder = Number(this.dataset.minimumOrder) || 5;
          this.qualifyingProductIds = new Set(
            (this.dataset.minimumProductIds || '').split(',').map((id) => id.trim()).filter(Boolean)
          );
          this.filterButtons = Array.from(this.querySelectorAll('[data-filter]'));
          this.productCards = Array.from(this.querySelectorAll('[data-product-card]'));
          this.progressBar = this.querySelector('[data-cart-progress]');
          this.bindFilters();
          this.bindVariantSelectors();
          this.bindProductForms();
          this.bindCartControls();
          this.checkoutGuard = (event) => this.guardCheckout(event);
          document.addEventListener('click', this.checkoutGuard, true);
          document.addEventListener('submit', this.checkoutGuard, true);
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
          }
          this.refreshCart();
        }

        disconnectedCallback() {
          if (this.unsubscribeCart) this.unsubscribeCart();
          document.removeEventListener('click', this.checkoutGuard, true);
          document.removeEventListener('submit', this.checkoutGuard, true);
        }

        bindFilters() {
          this.filterButtons.forEach((button) => {
            if (button.tagName !== 'BUTTON') return;
            button.addEventListener('click', () => {
              const filter = button.dataset.filter;
              this.filterButtons.forEach((item) => {
                if (item.tagName !== 'BUTTON') return;
                const active = item === button;
                item.classList.toggle('is-active', active);
                item.setAttribute('aria-pressed', String(active));
              });
              this.productCards.forEach((card) => {
                const collections = (card.dataset.collections || '').split(' ');
                card.hidden = filter !== 'all' && !collections.includes(filter);
              });
            });
          });
        }

        bindVariantSelectors() {
          this.querySelectorAll('[data-variant-select]').forEach((select) => {
            select.addEventListener('change', () => this.updateSelectedVariant(select));
          });
        }

        bindProductForms() {
          this.querySelectorAll('[data-quick-add-form]').forEach((form) => {
            form.addEventListener('submit', (event) => this.addToCart(event, form));
          });
        }

        bindCartControls() {
          this.querySelectorAll('[data-cart-step]').forEach((button) => {
            button.addEventListener('click', () => this.changeCartQuantity(button));
          });
        }

        async addToCart(event, form) {
          event.preventDefault();
          const button = form.querySelector('[type="submit"]');
          const spinner = form.querySelector('[data-submit-spinner]');
          const error = form.querySelector('[data-product-error]');
          const card = form.closest('[data-product-card]');
          if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
          if (!card || card.dataset.available !== 'true') return;
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
          if (spinner) spinner.hidden = false;
          if (error) error.hidden = true;

          try {
            const formData = new FormData(form);
            const notification = document.querySelector('cart-notification');
            if (notification && typeof notification.getSectionsToRender === 'function') {
              formData.append('sections', notification.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);
              if (typeof notification.setActiveElement === 'function') notification.setActiveElement(button);
            }
            const response = await fetch(window.routes.cart_add_url, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: formData,
            });
            const state = await response.json();
            if (!response.ok || state.status) throw new Error(state.description || state.message || this.dataset.cartError);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'ma-hawa-shop',
                productVariantId: formData.get('id'),
                cartData: state,
              });
            }
            if (notification && state.sections && typeof notification.renderContents === 'function') {
              notification.renderContents(state);
            }
            await this.refreshCart();
          } catch (cartError) {
            if (error) {
              error.textContent = cartError.message || this.dataset.cartError;
              error.hidden = false;
            }
          } finally {
            button.removeAttribute('aria-busy');
            button.disabled = card.dataset.available !== 'true';
            if (spinner) spinner.hidden = true;
          }
        }

        async changeCartQuantity(button) {
          const controls = button.closest('[data-in-cart-controls]');
          if (!controls || controls.dataset.busy === 'true') return;
          const lineKey = controls.dataset.lineKey;
          const current = Number(controls.dataset.quantity) || 0;
          const increment = Number(controls.dataset.increment) || 1;
          const quantity = button.dataset.cartStep === 'plus' ? current + increment : Math.max(0, current - increment);
          if (!lineKey) return;
          controls.dataset.busy = 'true';
          controls.setAttribute('aria-busy', 'true');
          controls.querySelectorAll('button').forEach((controlButton) => {
            controlButton.disabled = true;
          });
          try {
            const response = await fetch(window.routes.cart_change_url, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                id: lineKey,
                quantity,
                sections: ['cart-icon-bubble'],
                sections_url: window.location.pathname,
              }),
            });
            const state = await response.json();
            if (!response.ok || state.status) throw new Error(state.description || state.message || this.dataset.cartError);
            this.updateCartBubble(state.sections ? state.sections['cart-icon-bubble'] : null);
            this.updateFromCart(state);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ma-hawa-shop', cartData: state });
            }
          } catch (cartError) {
            const card = controls.closest('[data-product-card]');
            const error = card ? card.querySelector('[data-product-error]') : null;
            if (error) {
              error.textContent = cartError.message || this.dataset.cartError;
              error.hidden = false;
            }
          } finally {
            controls.dataset.busy = 'false';
            controls.removeAttribute('aria-busy');
            controls.querySelectorAll('button').forEach((controlButton) => {
              controlButton.disabled = false;
            });
          }
        }

        async refreshCart() {
          try {
            const response = await fetch(`${window.routes.cart_url}.js`, {
              headers: { Accept: 'application/json' },
            });
            if (!response.ok) return;
            this.updateFromCart(await response.json());
          } catch (cartError) {
            return;
          }
        }

        updateFromCart(cart) {
          const itemCount = Number(cart.item_count) || 0;
          const qualifyingCount = (cart.items || []).reduce((total, item) => {
            if (!this.qualifyingProductIds.has(String(item.product_id))) return total;
            return total + (Number(item.quantity) || 0);
          }, 0);
          const remaining = Math.max(0, this.minimumOrder - qualifyingCount);
          this.currentCart = cart;
          const bottomCartCount = document.querySelector('[data-bottom-cart-count]');
          if (bottomCartCount) {
            bottomCartCount.hidden = itemCount === 0;
            bottomCartCount.textContent = itemCount > 99 ? '99+' : String(itemCount);
          }
          if (this.progressBar) {
            this.progressBar.hidden = itemCount === 0;
            const message = this.progressBar.querySelector('[data-progress-message]');
            const fill = this.progressBar.querySelector('[data-progress-fill]');
            const total = this.progressBar.querySelector('[data-cart-total]');
            if (message) {
              const template = qualifyingCount >= this.minimumOrder ? this.dataset.readyTemplate : this.dataset.progressTemplate;
              message.textContent = this.fillTemplate(template, {
                current: qualifyingCount,
                remaining,
              });
            }
            if (fill) fill.style.width = `${Math.min(100, (qualifyingCount / this.minimumOrder) * 100)}%`;
            if (total) total.textContent = this.formatMoney(cart.total_price, cart.currency);
          }

          this.productCards.forEach((card) => {
            const variantId = String(card.dataset.variantId);
            const items = (cart.items || []).filter((item) => String(item.variant_id) === variantId);
            const controls = card.querySelector('[data-in-cart-controls]');
            const addAction = card.querySelector('[data-add-action]');
            const available = card.dataset.available === 'true';
            const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
            if (addAction) addAction.hidden = available && quantity > 0;
            if (controls) {
              controls.hidden = !available || quantity === 0;
              controls.dataset.lineKey = items[0] ? items[0].key : '';
              controls.dataset.quantity = String(items[0] ? items[0].quantity : 0);
              const output = controls.querySelector('[data-cart-quantity]');
              const label = controls.querySelector('[data-in-cart-label]');
              if (output) output.textContent = String(quantity);
              if (label) label.textContent = this.fillTemplate(this.dataset.inCartTemplate, { count: quantity });
            }
          });
          this.updateCheckoutState(qualifyingCount);
        }

        updateSelectedVariant(select) {
          const card = select.closest('[data-product-card]');
          const option = select.selectedOptions[0];
          if (!card || !option) return;
          const available = option.dataset.available === 'true';
          const price = card.querySelector('[data-price]');
          const comparePrice = card.querySelector('[data-compare-price]');
          const addAction = card.querySelector('[data-add-action]');
          const addLabel = addAction ? addAction.querySelector('[data-submit-label]') : null;
          const quantity = card.querySelector('input[name="quantity"]');
          const controls = card.querySelector('[data-in-cart-controls]');
          const availability = card.querySelector('[data-availability]');
          const error = card.querySelector('[data-product-error]');

          card.dataset.variantId = select.value;
          card.dataset.available = String(available);
          card.classList.toggle('is-unavailable', !available);
          if (price) price.textContent = option.dataset.price || '';
          if (comparePrice) {
            comparePrice.textContent = option.dataset.comparePrice || '';
            comparePrice.hidden = option.dataset.compareActive !== 'true';
          }
          if (addAction) addAction.disabled = !available;
          if (addLabel) addLabel.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
          if (availability) availability.hidden = available;
          if (quantity) quantity.value = option.dataset.minimum || '1';
          if (controls) controls.dataset.increment = option.dataset.increment || '1';
          if (error) error.hidden = true;
          if (this.currentCart) this.updateFromCart(this.currentCart);
        }

        updateCheckoutState(qualifyingCount) {
          const locked = qualifyingCount < this.minimumOrder;
          const remaining = Math.max(0, this.minimumOrder - qualifyingCount);
          this.checkoutLocked = locked;
          document.querySelectorAll('[data-ma-hawa-minimum-checkout]').forEach((button) => {
            button.disabled = locked;
            button.setAttribute('aria-disabled', String(locked));
          });
          document.querySelectorAll('[data-ma-hawa-minimum-message]').forEach((message) => {
            message.textContent = locked
              ? this.fillTemplate(this.dataset.checkoutMessage, { remaining })
              : this.fillTemplate(this.dataset.checkoutReadyTemplate, { current: qualifyingCount });
          });
          document.querySelectorAll('[data-ma-hawa-dynamic-checkout]').forEach((container) => {
            container.hidden = locked;
          });
        }

        guardCheckout(event) {
          if (!this.checkoutLocked) return;
          const target = event.target;
          const checkoutButton = target.closest ? target.closest('[data-ma-hawa-minimum-checkout]') : null;
          const checkoutForm = target.matches && target.matches('form')
            ? target.querySelector('[data-ma-hawa-minimum-checkout]')
            : null;
          if (!checkoutButton && !checkoutForm) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const message = document.querySelector('[data-ma-hawa-minimum-message]');
          if (message) message.setAttribute('aria-live', 'assertive');
        }

        updateCartBubble(html) {
          const bubble = document.getElementById('cart-icon-bubble');
          if (!bubble || !html) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const section = parsed.querySelector('.shopify-section');
          bubble.innerHTML = section ? section.innerHTML : parsed.body.innerHTML;
        }

        fillTemplate(template, values) {
          return Object.entries(values).reduce(
            (result, [key, value]) => result.replaceAll(`[${key}]`, String(value)),
            template || ''
          );
        }

        formatMoney(cents, currency) {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: currency || 'AED',
            }).format((Number(cents) || 0) / 100);
          } catch (formatError) {
            return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency || 'AED'}`;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('ma-hawa-product-motion')) {
    customElements.define(
      'ma-hawa-product-motion',
      class MaHawaProductMotion extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.dataset.motionReady = 'true';
          this.dataset.reducedMotion = String(this.reducedMotion);
          this.addButton = this.querySelector('.product-form__submit');
          this.addButtonLabel = this.addButton ? this.addButton.querySelector('span') : null;
          this.quantityInput = this.querySelector('.quantity__input');
          this.gallery = this.querySelector('.ma-hawa-product__gallery');
          this.factGroup = this.querySelector('.ma-hawa-product-facts');
          this.handleClick = (event) => this.onClick(event);
          this.handleQuantityChange = () => this.animateQuantity();
          this.addEventListener('click', this.handleClick);
          if (this.quantityInput) this.quantityInput.addEventListener('change', this.handleQuantityChange);
          this.prepareFactReveal();

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
          }
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          if (this.quantityInput) this.quantityInput.removeEventListener('change', this.handleQuantityChange);
          if (this.unsubscribeCart) this.unsubscribeCart();
          if (this.factObserver) this.factObserver.disconnect();
          window.clearTimeout(this.successTimer);
          window.clearTimeout(this.galleryTimer);
          window.clearTimeout(this.quantityTimer);
        }

        prepareFactReveal() {
          if (!this.factGroup) return;
          this.factGroup.classList.add('is-motion-ready');
          if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
            this.factGroup.classList.add('is-visible');
            return;
          }
          this.factObserver = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.factGroup.classList.add('is-visible');
              this.factObserver.disconnect();
            },
            { threshold: 0.24 }
          );
          this.factObserver.observe(this.factGroup);
        }

        onClick(event) {
          if (event.target.closest('.quantity__button')) {
            window.requestAnimationFrame(() => this.animateQuantity());
          }
          if (event.target.closest('.thumbnail')) {
            this.animateGallery();
          }
        }

        animateQuantity() {
          const quantityInput = this.querySelector('.quantity__input');
          if (!quantityInput || this.reducedMotion) return;
          this.quantityInput = quantityInput;
          quantityInput.classList.remove('is-changing');
          void quantityInput.offsetWidth;
          quantityInput.classList.add('is-changing');
          window.clearTimeout(this.quantityTimer);
          this.quantityTimer = window.setTimeout(() => quantityInput.classList.remove('is-changing'), 240);
        }

        animateGallery() {
          if (!this.gallery || this.reducedMotion) return;
          this.gallery.classList.remove('is-transitioning');
          void this.gallery.offsetWidth;
          this.gallery.classList.add('is-transitioning');
          window.clearTimeout(this.galleryTimer);
          this.galleryTimer = window.setTimeout(() => this.gallery.classList.remove('is-transitioning'), 380);
        }

        onCartUpdate(event) {
          if (!event || event.source !== 'product-form') return;
          const variantInput = this.querySelector('.product-variant-id');
          if (variantInput && String(event.productVariantId) !== String(variantInput.value)) return;
          this.showSuccess();
        }

        showSuccess() {
          if (!this.addButton || !this.addButtonLabel) return;
          if (!this.defaultButtonLabel) this.defaultButtonLabel = this.addButtonLabel.textContent.trim();
          this.addButton.classList.remove('is-success');
          void this.addButton.offsetWidth;
          this.addButton.classList.add('is-success');
          this.addButtonLabel.textContent = `✓ ${this.dataset.successLabel}`;
          window.clearTimeout(this.successTimer);
          this.successTimer = window.setTimeout(() => {
            this.addButton.classList.remove('is-success');
            this.addButtonLabel.textContent = this.defaultButtonLabel;
          }, 1100);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
